import React from 'react';
import { NavigationIcon } from 'lucide-react';
import { StudioGallery } from './StudioGallery';
import { SectionHeading } from './SectionHeading';
import { business, numeros } from '../data/business';
export function LocationSection() {
  return <section className="px-4 pt-12" aria-labelledby="titulo-local" data-id="element-87" data-mp="1i7as0qhlw691">
      <SectionHeading id="titulo-local" overline="Onde atendo" titulo="O consultório" descricao="Ambiente reservado, silencioso e acessível — deslize para conhecer o espaço." data-id="element-88" data-mp="1de85317c3v1t" />

      <StudioGallery data-id="element-89" data-mp="1n4knamrofc4s" />

      <dl className="mt-6 grid grid-cols-3 divide-x divide-shell rounded-2xl border border-shell bg-white/60 py-4" data-id="element-90" data-mp="1n76uglannpmh">
        {numeros.map(numero => <div key={numero.id} className="flex flex-col items-center px-2 text-center" data-id="element-91" data-mp="1x4biyrrz3x6g">
            <dt className="font-display text-[26px] leading-none text-ink" data-id="element-92" data-mp="6q2mg1v84k3a">{numero.valor}</dt>
            <dd className="mt-2 text-[11px] leading-tight text-muted" data-id="element-93" data-mp="2pr10mv1efqr">{numero.descricao}</dd>
          </div>)}
      </dl>

      <div className="mt-5 overflow-hidden rounded-2xl border border-shell bg-white/60" data-id="element-94" data-mp="2mrwtqnc511ls">
        <iframe title={`Mapa com a localização do ${business.nome}`} src={business.mapaEmbed} loading="lazy" className="h-44 w-full border-0 grayscale-[35%]" data-id="element-95" data-mp="2rqq8ej35uynj" />
        <div className="p-4" data-id="element-96" data-mp="31g9uryq31an5">
          <p className="text-[14px] leading-snug text-ink" data-id="element-97" data-mp="31hkv1okbk09i">{business.endereco}</p>
          <p className="mt-0.5 text-[12.5px] text-muted" data-id="element-98" data-mp="36ebe8krf7bz5">{business.complemento}</p>
          <a href={business.mapsUrl} target="_blank" rel="noreferrer" className="mt-3.5 flex w-full items-center justify-center gap-2 rounded-xl bg-sand py-3 text-[14px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-shell active:bg-shell focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-99" data-mp="3aev7hd8vhvg0">
            <NavigationIcon className="h-4 w-4 text-mocha" strokeWidth={1.6} data-id="element-100" data-mp="1q2fk5xa1avet" />
            Abrir no Google Maps
          </a>
        </div>
      </div>

      <div className="mt-3 overflow-hidden rounded-2xl border border-shell bg-white/60" data-id="element-101" data-mp="1dytpkkabxdq2">
        <p className="eyebrow border-b border-shell px-4 py-3 text-[10px] font-medium text-mocha" data-id="element-102" data-mp="1rycm0fts30mj">
          Horários
        </p>
        <dl className="divide-y divide-shell" data-id="element-103" data-mp="1mxyhv8vasats">
          {business.horarios.map(horario => <div key={horario.dias} className="flex items-center justify-between px-4 py-3" data-id="element-104" data-mp="20x6kkbqo612q">
              <dt className="text-[13.5px] text-muted" data-id="element-105" data-mp="1ww4kxtsubn08">{horario.dias}</dt>
              <dd className="text-[13.5px] font-medium text-ink" data-id="element-106" data-mp="2aouc0cn87i47">{horario.horas}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}